import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, adminHeaders } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
        const [token, setToken] = useState("");
        const [error, setError] = useState("");
        const [loading, setLoading] = useState(false);
        const navigate = useNavigate();

        useEffect(() => {
                const checkAuth = async () => {
                        try {
                                await api.get("/admin/topics", { headers: adminHeaders() });
                                navigate("/admin/painel");
                        } catch {
                                // Cookie doesn't exist or is invalid, do nothing and show login form
                        }
                };
                checkAuth();
        }, [navigate]);

        const submit = async (e) => {
                e.preventDefault();
                setError("");
                setLoading(true);
                try {
                        await api.post("/admin/login", { token });
                        navigate("/admin/painel");
                } catch {
                        setError("Credenciais inválidas.");
                } finally {
                        setLoading(false);
                }
        };

        return (
                <main className="admin-ui flex min-h-screen items-center justify-center bg-[var(--bg)] px-6 py-16">
                        <div className="adm-card w-full max-w-sm p-8">
                                <div className="mb-6 flex items-center gap-3">
                                        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[var(--controversy)] text-sm font-bold text-white">
                                                VO
                                        </div>
                                        <div>
                                                <div className="text-sm font-semibold leading-tight text-[var(--ink)]">
                                                        Verdade Oculta
                                                </div>
                                                <div className="text-[11px] leading-tight text-[var(--ink-faint)]">
                                                        Consola editorial
                                                </div>
                                        </div>
                                </div>
                                <h1 className="text-xl font-semibold tracking-tight text-[var(--ink)]">
                                        Acesso restrito
                                </h1>
                                <p className="mt-2 text-sm text-[var(--ink-soft)]">
                                        Introduza o token de administração para entrar na consola.
                                </p>

                                <form onSubmit={submit} className="mt-8 space-y-5">
                                        <div>
                                                <label className="overline mb-2 flex items-center gap-1.5 text-[var(--ink-soft)]">
                                                        <Lock size={11} strokeWidth={1.75} /> Token
                                                </label>
                                                <input
                                                        type="password"
                                                        data-testid={ADMIN.loginInput}
                                                        value={token}
                                                        onChange={(e) => setToken(e.target.value)}
                                                        className="w-full border bg-transparent px-4 py-3 font-mono focus:outline-none"
                                                        style={{ borderColor: "var(--line-strong)" }}
                                                        placeholder="••••••••"
                                                        autoFocus
                                                />
                                        </div>
                                        {error && (
                                                <p
                                                        data-testid={ADMIN.loginError}
                                                        className="text-sm font-medium"
                                                        style={{ color: "var(--deception)" }}
                                                >
                                                        {error}
                                                </p>
                                        )}
                                        <button
                                                type="submit"
                                                data-testid={ADMIN.loginSubmit}
                                                disabled={loading || !token}
                                                className="adm-btn adm-btn-primary w-full"
                                        >
                                                {loading ? "A entrar..." : "Entrar"}
                                        </button>
                                </form>
                                <p className="mt-6 text-center">
                                        <Link
                                                to="/"
                                                className="text-sm text-[var(--ink-soft)] transition-colors hover:text-[var(--controversy)]"
                                        >
                                                ← Voltar ao site público
                                        </Link>
                                </p>
                        </div>
                </main>
        );
}
